module.exports = __webpack_public_path__ + "media/images/banners/3-1d303ca6181efa4f500f8f2083e1f775.jpg";